import React, { Component } from 'react';
import format from 'string-format';
import Util from '../utils/Util.js';

class Social extends Component {
	constructor(props) {
		super(props);

		this.baseCls = "social";

		if( !Util.isEmpty(props.color) )
			this.baseCls += format(' {0}', props.color);

		if( !Util.isEmpty(props.align) ) {
			switch(props.align) {
				case "left":
					this.baseCls += format(' {0}', "justify-content-start");
					break;
				case "right":
					this.baseCls += format(' {0}', "justify-content-end");
					break;
				case "center":
					this.baseCls += format(' {0}', "justify-content-center");
					break;
				default:
			}
		} else {
			this.baseCls += format(' {0}', "justify-content-center");
		}

		this.linkClick = this.linkClick.bind(this);
	}

	linkClick(ev, social) {
		ev.preventDefault();

		if( !Util.isEmpty(this.props.onClick) ) {
			this.props.onClick(social);
		}
	}

	render() {
		return (
			<div className={this.baseCls}>
				{/* Facebook link */}
				<a href="#top" className="social-item" onClick={e => this.linkClick(e, "facebook")}>
					<svg className="social-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 54.3 53.6">
						<path d="M43.2,9c0.1,0,0.3,0.1,0.4,0.1c0.8,0.2,1.4,1,1.4,1.8c0,0.1,0,0.1,0,0.2c0,10.5,0,20.9,0,31.4c0,1-0.5,1.7-1.3,2c-0.2,0.1-0.4,0.1-0.7,0.1c-2.9,0-5.8,0-8.7,0c-0.1,0-0.2,0-0.3,0c0-4.6,0-9.1,0-13.7c0.1,0,0.2,0,0.3,0c1.3,0,2.6,0,3.8,0c0.3,0,0.4-0.1,0.5-0.4c0.2-1.6,0.4-3.2,0.6-4.8c0,0,0-0.1,0-0.2c-1.8,0-3.5,0-5.3,0c0-0.1,0-0.2,0-0.3c0-1,0-2.1,0-3.1c0-0.3,0-0.6,0.1-1c0.2-1,0.9-1.5,1.9-1.6c1,0,2.1,0,3.1,0c0.3,0,0.4-0.1,0.4-0.4c0-1.4,0-2.8,0-4.1c0-0.3,0-0.4-0.3-0.4c-1.8-0.1-3.6-0.3-5.3,0c-2.7,0.4-4.7,2.3-5.2,4.9c-0.1,0.7-0.2,1.5-0.2,2.2c0,1.1,0,2.3,0,3.4c0,0.1,0,0.2,0,0.4c-0.2,0-0.3,0-0.4,0c-1.3,0-2.6,0-4,0c-0.2,0-0.3,0.1-0.3,0.3c0,1.6,0,3.2,0,4.8c0,0.2,0.1,0.3,0.3,0.3c1.3,0,2.6,0,4,0c0.1,0,0.2,0,0.4,0c0,4.6,0,9.1,0,13.7c-0.1,0-0.2,0-0.3,0c-5.5,0-11,0-16.5,0c-1.2,0-2.1-0.8-2.1-2.1c0-10.5,0-20.9,0-31.4C9.4,10,9.9,9.3,11,9c0,0,0.1,0,0.1-0.1C21.8,9,32.5,9,43.2,9z"/>
					</svg>
				</a>
				{/* LinkedIn link */}
				<a href="#top" className="social-item" onClick={e => this.linkClick(e, "linkedin")}>
					<svg className="social-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 54.3 53.6">
						<path d="M44.9,10.9c0-0.9-0.6-1.6-1.4-1.8c-0.1,0-0.3-0.1-0.4-0.1c-10.7,0-21.4,0-32,0c0,0-0.1,0-0.1,0.1C9.9,9.3,9.4,10,9.4,11.1c0,10.5,0,20.9,0,31.4c0,1.2,0.8,2.1,2.1,2.1c5.5,0,28.6,0,31.5,0c0.2,0,0.5,0,0.7-0.1c0.9-0.3,1.3-1,1.3-2c0-10.5,0-20.9,0-31.4C44.9,11,44.9,11,44.9,10.9z M20.8,39.9c0,0-0.1,0-0.1,0c-1.8,0-3.6,0-5.4,0c-0.1,0-0.1,0-0.1-0.1c0-3.1,0-6.3,0-9.4c0-1.6,0-3.3,0-4.9c0-0.8,0-1.6,0-2.4c0,0,0-0.1,0-0.1c1.9,0,3.8,0,5.7,0C20.8,28.5,20.8,34.2,20.8,39.9z M20.3,19.6c-0.4,0.5-1,0.8-1.7,0.9c-0.8,0.1-1.5,0.1-2.2-0.2c-1.1-0.5-1.6-1.4-1.6-2.6c0-1.4,0.9-2.5,2.3-2.8c0.3-0.1,0.5-0.1,0.8-0.1c0.6,0,1.2,0.1,1.8,0.5c0.7,0.5,1.1,1.1,1.3,2C21.1,18.2,20.9,19,20.3,19.6zM40.5,39.9c-1.9,0-3.8,0-5.7,0c0-0.1,0-0.1,0-0.2c0-3.1,0-6.2,0-9.3c0-0.7-0.1-1.3-0.3-2c-0.2-0.6-0.5-1.1-1.2-1.4c-0.4-0.2-0.9-0.2-1.3-0.2c-1.1,0.1-1.8,0.6-2.3,1.5c-0.3,0.5-0.4,1.1-0.4,1.7c0,3.2,0,6.4,0,9.6c0,0.1,0,0.1,0,0.2c-1.9,0-3.8,0-5.8,0c0-5.7,0-11.3,0-17c1.9,0,3.8,0,5.7,0c0,0.8,0,1.6,0,2.3c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0.5-0.7,1-1.3,1.8-1.8c0.6-0.4,1.2-0.6,1.9-0.7c1-0.1,2-0.1,3,0.2c1.7,0.5,2.9,1.5,3.7,3.1c0.4,0.8,0.6,1.7,0.7,2.7c0,0.5,0.1,1,0.1,1.6c0,3.2,0,6.4,0,9.6C40.5,39.8,40.5,39.8,40.5,39.9z"/>
					</svg>
				</a>
				{/* Twitter link */}
				<a href="#top" className="social-item" onClick={e => this.linkClick(e, "twitter")}>
					<svg className="social-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 54.3 53.6">
						<path d="M9.4,38.5c3.9,0.3,7.4-0.6,10.6-3c-3.3-0.4-5.5-2.1-6.8-5.3c1,0,2,0,2.9,0c0-0.1,0-0.1,0.1-0.2c-1.6-0.5-3-1.4-4-2.7c-1-1.4-1.5-2.9-1.5-4.6c1,0.3,2,0.6,3,0.9c0-0.1,0.1-0.1,0.1-0.2c-1.5-1.2-2.5-2.7-2.8-4.5c-0.4-1.9-0.1-3.7,0.9-5.4c4,4.8,8.9,7.4,15,7.9c0-0.9-0.1-1.8,0-2.6c0.4-3,2-5.2,4.8-6.2c2.8-1,5.3-0.4,7.5,1.6c0.3,0.2,0.5,0.3,0.8,0.2c1.3-0.3,2.6-0.8,3.7-1.5c0.1-0.1,0.2-0.1,0.5-0.2c-0.5,1.7-1.5,3-2.8,4c1.3-0.1,2.5-0.5,3.7-0.9c-0.1,0.2-0.2,0.4-0.4,0.5c-0.9,1-1.8,2-2.8,2.9c-0.3,0.3-0.4,0.5-0.4,0.9c0,6.2-2.1,11.5-6.3,15.9c-2.8,2.9-6.1,4.7-10,5.5c-5.5,1.2-10.7,0.3-15.5-2.7c0,0-0.1-0.1-0.1-0.1C9.4,38.7,9.4,38.7,9.4,38.5z"/>
					</svg>
				</a>
				{/* Slak link */}
				<a href="#top" className="social-item" onClick={e => this.linkClick(e, "slak")}>
					<svg className="social-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 54.3 53.6">
						<g>
							<path d="M44.9,10.9c0-0.9-0.6-1.6-1.4-1.8c-0.1,0-0.3-0.1-0.4-0.1c-10.7,0-21.4,0-32,0c0,0-0.1,0-0.1,0.1C9.9,9.3,9.4,10,9.4,11.1c0,10.5,0,20.9,0,31.4c0,1.2,0.8,2.1,2.1,2.1c5.5,0,28.6,0,31.5,0c0.2,0,0.5,0,0.7-0.1c0.9-0.3,1.3-1,1.3-2c0-10.5,0-20.9,0-31.4C44.9,11,44.9,11,44.9,10.9z M39.6,31.1c0,0-1,0.3-2.5,0.8c0.5,1.6,0.8,2.6,0.8,2.6c0.4,1.3-0.4,2.7-1.7,3.1c-1.3,0.4-2.6-0.3-3.1-1.6l-0.8-2.6c-1.7,0.6-3.6,1.2-5.3,1.7c0.5,1.6,0.8,2.6,0.8,2.6c0.4,1.3-0.4,2.7-1.7,3.1c-1.3,0.4-2.6-0.3-3.1-1.6l-0.8-2.6c-1.6,0.5-2.6,0.8-2.6,0.8c-1.3,0.4-2.7-0.4-3.1-1.7c-0.4-1.3,0.3-2.6,1.6-3.1l2.6-0.8L19,26.7c-1.6,0.5-2.6,0.8-2.6,0.8c-1.3,0.4-2.7-0.4-3.1-1.7c-0.4-1.3,0.3-2.6,1.6-3.1l2.6-0.8l-0.8-2.5c-0.4-1.3,0.3-2.7,1.6-3.2c1.3-0.4,2.7,0.3,3.2,1.6c0,0,0.3,1,0.8,2.5l5.3-1.7l-0.8-2.5c-0.4-1.3,0.3-2.7,1.6-3.2c1.3-0.4,2.7,0.3,3.2,1.6c0,0,0.3,1,0.8,2.5l2.5-0.8c1.3-0.4,2.7,0.3,3.2,1.6s-0.3,2.7-1.6,3.2c0,0-1,0.3-2.5,0.8c0.6,1.7,1.2,3.6,1.7,5.3l2.5-0.8c1.3-0.4,2.7,0.3,3.2,1.6S41,30.7,39.6,31.1z"/>
							<path d="M23.8,25.2c0.6,1.7,1.2,3.6,1.7,5.3l5.3-1.7l-1.7-5.3C27.4,24,25.5,24.6,23.8,25.2z"/>
						</g>
					</svg>
				</a>
			</div>
		);
	}
}

export default Social;